import { gql } from "generated/gql"

export const GET_INVOICES_QUERY = gql(`
  query GetInvoices($clientId: ID!) {
    invoices(clientId: $clientId) {
      ...InvoiceFields
    }
  }
`)

export const CREATE_INVOICE_MUTATION = gql(`
  mutation CreateInvoice(
    $month: Int!
    $year: Int!
    $contractId: ID!
    $createInvoiceLineItems: [InvoiceLineItemInput!]
    $sendEmail: Boolean
  ) {
    mutationResult:createInvoice (input: {
      month: $month
      year: $year
      contractId: $contractId
      createInvoiceLineItems: $createInvoiceLineItems
      sendEmail: $sendEmail
    }) {
      id
      errors
      invoice {
        ...InvoiceFields
      }
    }
  }
`)

export const RESEND_INVOICE_MUTATION = gql(`
  mutation UpdateInvoice(
    $id: ID!
    $sendEmail: Boolean
  ) {
    mutationResult:updateInvoice (input: {
      id: $id
      sendEmail: $sendEmail
    }) {
      id
      errors
      invoice {
        ...InvoiceFields
      }
    }
  }
`)
